import sliceCreator from '../../index.jsx';
import {CREATE_TENANT_USER} from '../../../constants/index.jsx';
const _createTenantUserAction = sliceCreator('CREATE_TENANT_USER', CREATE_TENANT_USER, 'post');

const { asyncAction: createTenantUserAction, reducer, clearData: clearCreateTenantUserAction } = _createTenantUserAction;

export default reducer;

export {
    createTenantUserAction,
    clearCreateTenantUserAction
}